import React, { Fragment } from 'react'
import LogChart from '@modul-connect/shared/components/organisms/logChart'
import KpiRow from '@modul-connect/shared/components/molecules/kpiRow/kpiRow'
import theme from '@modul-connect/shared/theme'
import { getBatteryWarningColor } from '../../../../../utils/vehicleUtils'
import { getDaysDifference, getTicks } from './logGraphs'
import { useTranslation } from 'react-i18next'

const BatteryLogGraph = ({
  vehicle,
  logs,
  log_loading,
  showBatteryId,
  batteryId,
  oldPicker,
  setStartTime,
  setEndTime,
  startTime,
  endTime
}) => {

  const {t} = useTranslation()
  
  const defaultBatteryGuard = 11.7
  const lowerBatteryGuard = (logs?.length && vehicle?.vehicle?.batteryGuards?.length) ? 
    vehicle?.vehicle?.batteryGuards.find(guard => guard.batteryId === batteryId)?.lowGuard ?? defaultBatteryGuard 
    : defaultBatteryGuard

  const kpiData_battery = vehicle?.currentStatus?.batteries.map(battery => {
    return {
      title: `${t('vehicleDetails.currentVoltage')}${
        showBatteryId && (battery?.id || battery.id === 0)
          ? ` — ID ${battery.id}`
          : ''
      }`,      value: (battery.voltage || battery.voltage === 0) ? battery.voltage.toFixed(1) : '-',
      unit: 'V',
      color: (!battery.voltage && battery.voltage !== 0) ? theme.colors.text : getBatteryWarningColor(battery.voltage, lowerBatteryGuard)
    }
  })
  return (
    <Fragment>
      {
        (vehicle?.currentStatus?.batteries?.length || log_loading.fetchBatteryLogs !== 'loading') &&
        <KpiRow width={'100%'} data={kpiData_battery} />
      }
      {
        <LogChart
          oldPicker={oldPicker}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          startTime={startTime}
          endTime={endTime}
          data={logs ? logs.map(log => {
            return { 
              boxId: log.boxId,
              id: log.id,
              telematicsId: log.telematicsId,
              timestamp: log.timestamp,
              voltage: log.voltage.toFixed(1),
              max: lowerBatteryGuard
            }}) : []}
          data_key="voltage"
          data_name={t('vehicleDetails.batteryVoltage')}
          max_name={t('vehicleDetails.battery.minVoltage')}
          title={`${t('vehicleDetails.batteryVoltage')}${
            showBatteryId ? ` (Id: ${batteryId})` : ''
          }`}          
          unit="V"
          line_type={'stepAfter'}
          domain={[
            0,
            logs ? Math.max(
              lowerBatteryGuard + 1,
              Math.ceil(Math.max(...logs.map(log => log.voltage)) * 10) / 10) + 1
              : 15
          ]}
          displayTimeInHours={getDaysDifference(startTime, endTime) <= 1}
          ticks={getTicks(null, true, startTime, endTime)}
        />
      }
    </Fragment>
  )
}

export default BatteryLogGraph


